import { useContext, useEffect } from 'react';
import { Box, Button, SkeletTable } from '@alf/uikit';
import { LOG_ACTIONS, useLogAmplitude } from '@namespace/analytics';
import { BonusHunterWrapper, SelfExcludedWrapper } from '@namespace/common';
import { DATE_FORMATS_TYPES, useI18n } from '@namespace/i18n';
import { UserContext } from '@namespace/user';
import { PersonalOfficeWrapper } from '../../../../account';
import { BonusCardByType } from '../../common/BonusCardByType';
import EmptyBonusList from '../../common/EmptyBonusList';
import { useAllTypesBonusesHistoryFetchCallbacks } from '../../hooks/useAllTypesBonusesHistoryFetchCallbacks';
import { useBonusesStore } from '../../store';

import styles from './index.module.css';

const AllTypesBonusesHistoryListCommon = () => {
  const { t, f } = useI18n();
  const logAmplitude = useLogAmplitude();
  const allTypesBonusesHistory = useBonusesStore('allTypesBonusesHistory');
  const { ids: bonusesIds, isNextPageExist } = allTypesBonusesHistory;
  const {
    loadBonusesHistoryList,
    loadMoreBonusesHistoryList,
    isFetchingBonuses,
    isFetchingMoreBonuses
  } = useAllTypesBonusesHistoryFetchCallbacks();
  const [user] = useContext(UserContext);
  const { registrationDate } = user;

  useEffect(() => {
    logAmplitude({
      actionName: LOG_ACTIONS.BONUSES_OPEN,
      attributes: {
        bonus_tab: 'bonuses',
        registration_date: f
          .getDateTime({ date: registrationDate?.replace('Z', '') }) // time on UTC-0
          .toFormat(DATE_FORMATS_TYPES.API_WITH_TIME),
        history: true
      }
    });
    loadBonusesHistoryList();
  }, []);

  if (isFetchingBonuses) {
    return (
      <SkeletTable
        classNames={{
          classNameItem: styles.skeletHeight,
          classNameWrapper: styles.skeletWrapper
        }}
      />
    );
  }

  return (
    <Box component={PersonalOfficeWrapper} direction="column">
      {!bonusesIds.length && (
        <EmptyBonusList
          title={t('web.personaloffice.bonuses.title.emptylisthistory')}
        />
      )}
      {bonusesIds.length > 0 && (
        <>
          {bonusesIds.map((bonusId) => (
            <BonusCardByType key={bonusId} bonusId={bonusId} />
          ))}
          {isNextPageExist && (
            <Button
              size="m"
              actionType="color3"
              intent="quaternary"
              onClick={loadMoreBonusesHistoryList}
              className={styles.showMoreButton}
              processing={isFetchingMoreBonuses}
            >
              {t('web.personaloffice.bonuses.button.showmore')}
            </Button>
          )}
        </>
      )}
    </Box>
  );
};

export const AllTypesBonusesHistoryList = () => (
  <SelfExcludedWrapper>
    <BonusHunterWrapper>
      <AllTypesBonusesHistoryListCommon />
    </BonusHunterWrapper>
  </SelfExcludedWrapper>
);
